import axios from "axios";
import { setUser, removeUser, getUser } from "./token.service";
import { API_URL } from "../config/api";

class Auth {
  async login(username, password) {
    const response = await axios.post(API_URL + "token/", {
      username,
      password,
    });
    if (response.data.data.access) {
      setUser(response.data.data);
    }
    return response.data;
  }

  logout() {
    removeUser();
  }

  getCurrentUser() {
    return getUser();
  }

  setUser(user) {
    setUser(user);
  }
}

const AuthService = new Auth();

export default AuthService;
